export default {
    data: () => ({
        translations: {
            additionalInfo: {
                el: "",
                en: "Store Additional Info",
                it: ""
            },
            address: {
                el: "Διεύθυνση",
                en: "Address",
                it: "Indirizzo"
            },
            phone: {
                el: "",
                en: "Phone",
                it: ""
            },
            registrationDate: {
                el: "",
                en: "Registration Date",
                it: ""
            },
            availableBanks: {
                el: "",
                en: "Store Available Banks",
                it: ""
            }
        }
    })
};
